import { createStyles } from '@material-ui/core/styles';
import { withBaseProps } from '@topconagriculture/react-components';
import { Loader } from '@topconagriculture/loader';
import * as React from 'react';
import { compose } from 'recompose';
import withAuth0 from '../../hocs/withAuth0';
import ErrorHandler from '../ErrorHandler';
const styles = () => createStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        height: '100vh',
        width: '100%',
        justifyContent: 'center',
        alignContent: 'center',
    },
    loaderWrapper: {
        minHeight: '100vh',
        height: '100vh',
        width: '100%',
    },
});
const AuthPortal = ({ classes, auth, LoadingComponent, children }) => {
    if (auth.leewayError) {
        return React.createElement(ErrorHandler, null);
    }
    if (auth.isLoading) {
        if (LoadingComponent) {
            return React.createElement(LoadingComponent, null);
        }
        else {
            return (React.createElement("div", { className: classes.container },
                React.createElement(Loader, { classes: { loaderWrapper: classes.loaderWrapper } })));
        }
    }
    return children;
};
export default compose(withBaseProps({ styles }), withAuth0)(AuthPortal);
//# sourceMappingURL=AuthPortal.js.map